var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"browser-mockup"},[_vm._m(0),_c('div',{staticClass:"browser-content"},[_c('div',{staticClass:"content-container",domProps:{"innerHTML":_vm._s(_vm.markup)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar"},[_c('div',{staticClass:"circles"},[_c('span',{staticClass:"circle red"}),_c('span',{staticClass:"circle yellow"}),_c('span',{staticClass:"circle green"})])])
}]

export { render, staticRenderFns }